import React from "react";

import { Box } from "@chakra-ui/react";

export const CompanyPractiseProfileEditRoute: React.FC = () => (
  <Box>EditForm Placeholder</Box>
);
